module.exports = __webpack_public_path__ + "static/media/SectionGeometry.3facfb66.svg";